<template>
    <iframe id="iframe" :src="src" name="iframe" />
</template>

<script setup>
    const { url } = defineProps(['url']);
    const { iframeUrl } = useRuntimeConfig().public;

    let src = url ? `${iframeUrl}${url}` : iframeUrl;
    if (url.includes('http://') || url.includes('https://')) {
        src = url;
    }
</script>

<style scoped lang="scss">
    #iframe {
        width: 100vw;
        height: calc(100dvh - $header_height);
        padding-bottom: 0;
    }
</style>
